import styled from 'styled-components';
import { remCalc, layout } from '@prisjakt/ui-base';

const PAGE_MARGIN_BOTTOM = 30;

export const TrackingSettings = styled.div`
  margin-bottom: ${remCalc(PAGE_MARGIN_BOTTOM)};
`;

export const PersonalizationSettings = styled.div`
  margin-bottom: ${remCalc(PAGE_MARGIN_BOTTOM)};
`;

export const PersonalizationInterests = styled.div`
  padding-left: ${layout.pageContent.gutter.rem};
`;

export const PersonalizationDescription = styled.div`
  padding-left: ${layout.pageContent.gutter.rem};
`;
